import {
    AgentUserId
} from 'one-state-getuserid/src/model';
/**
 * This Function transforms the backend response
 * in the Data Model that supports the
 * Epic User Id Component
 * @param response has the backend
 * Epic User Id  component response
 * @param context has settings etc..
 */

export const TransformResponse = (response: any, context: any) => {
    /**
     * @param result contains the transformed response
     */
    let result :any = {
        agentiddata:[],
        error:undefined
    }

    const { log,settings } = context;
    const { compatible: { sso,contact_center_type } } = settings;
    // TODO:verify backend team check for errors
    if (response && (response.status >= 400 || response.type == "error")) {
        result.error=response;
     }

    // TODO:verify backend team check for errors
    if (response) {
       
        let info: AgentUserId = {
            agentuserid: "",
            modalvisible: true,
            }
        let agentinfo:AgentUserId[] =[]
        if(response.length > 0) {
            response.forEach((ele: any) => {
                
                if(ele) {
                    if(contact_center_type === "finesse") {
                        info.agentuserid = ele?.epic_user;
                    }
                    else if(contact_center_type === "five9") {
                        info.agentuserid = ele?.epic_user;
                    }
                    else if(contact_center_type === "wxcc") {
                        info.agentuserid = ele?.epic_user;
                    }

                    info.modalvisible = false;
                }
                agentinfo.push(info)
            });
            result.agentiddata=agentinfo;   
        }
        else if(response.length === 0 && sso === true) {
            info.agentuserid = "";
            info.modalvisible = false;
            agentinfo.push(info)
            result.agentiddata=agentinfo;
        }
        else if(response.length === 0 && sso === false) {
            agentinfo.push(info);
            result.agentiddata=agentinfo;  
        }
        
    }
    log.debug(
        "ccw-gadget,Agent-epic",
        "Agent-epic transformation response ", {
        result
    });
    return result;
}